/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { openPositionDetailResponseSchema } from './openPositionDetailResponseSchema';

export const pageResponseOpenPositionDetailResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(openPositionDetailResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
